import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface DateRangeFieldsProps {
  /** `yyyy-MM-dd`, the format every report endpoint expects. */
  start: string;
  end: string;
  onStartChange: (value: string) => void;
  onEndChange: (value: string) => void;
  startLabel?: string;
  endLabel?: string;
  disabled?: boolean;
}

/**
 * The from/to pair used by every filter toolbar.
 *
 * The two inputs are kept in one flex group so they wrap together: on their own they are taller
 * than the neighbouring controls (the floating label), which left "to" stranded on its own line.
 * On narrow screens the pair shrinks below its natural 168px each instead of overflowing.
 */
export function DateRangeFields({
  start,
  end,
  onStartChange,
  onEndChange,
  startLabel,
  endLabel,
  disabled,
}: DateRangeFieldsProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flex: '0 1 auto', minWidth: 0, maxWidth: '100%', gap: 1.25 }}>
      <TextField
        type="date"
        fullWidth={false}
        label={startLabel ?? t('range.from')}
        value={start}
        onChange={(event) => onStartChange(event.target.value)}
        disabled={disabled}
        sx={{ width: 168, minWidth: 0 }}
      />
      <TextField
        type="date"
        fullWidth={false}
        label={endLabel ?? t('range.to')}
        value={end}
        onChange={(event) => onEndChange(event.target.value)}
        disabled={disabled}
        sx={{ width: 168, minWidth: 0 }}
      />
    </Box>
  );
}
